import { Button, Watermark } from 'antd';
import React from 'react';
import { StaticImage } from './utils/images';
import { blackBeanColor } from './utils/const';
import { captureError } from './utils/monitoring';
import logger from './utils/logger';
// Class component: hooks are unavailable, and this renders on the crash path where
// reading the current language directly is sufficient.
import i18next from 'i18next';

/**
 * Application error boundary.
 *
 * This was previously a function component listening to `window.addEventListener('error')`,
 * which does NOT catch React render errors — the exact class of failure a boundary exists
 * for. A component that threw during render would take the whole tree down to a blank
 * screen without the fallback ever showing.
 *
 * React only supports error boundaries as class components: `getDerivedStateFromError`
 * renders the fallback, `componentDidCatch` reports the error with its component stack.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        logger.log('ErrorBoundary caught', error?.message);
        captureError(error, { componentStack: errorInfo?.componentStack });
    }

    render() {
        if (!this.state.hasError) return this.props.children;

        return (
            <Watermark
                style={{
                    display: 'grid',
                    placeItems: 'center',
                    minHeight: '100vh',
                    background: blackBeanColor,
                }}
                height={150}
                width={150}
                image={StaticImage.logo.blueLogo}
            >
                <div className="text-center rounded bg-danger p-5" style={{ opacity: 0.8, zIndex: 99 }}>
                    <h2 className="text-white">{i18next.t('common.somethingWentWrong')}</h2>
                    <Button className="commonButton" type="text" onClick={() => window.location.reload()}>
                        {i18next.t('common.reload')}
                    </Button>
                </div>
            </Watermark>
        );
    }
}

export default ErrorBoundary;
